<template>
  <div class="mailconfig" style="height: 100%">
    <div class="return">
      <el-button @click="submit" type="primary" class="searchBtn" :loading="loadingSave">{{$t('LanguageLib.SAVE')}}</el-button>
    </div>
    <div class="content">
      <div>
        <h4 class="title">{{$t('LanguageLib.REPAIR_MAIL_CONFIG')}}</h4>
        <div class="checkbox">
          <div
            class="checkboxItem"
            v-for="(item, index) in repaircheckList"
            :key="index"
            :title="item.typeName"
          >
            <el-checkbox v-model="item.isEnable">{{ item.typeName }}</el-checkbox>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import companyallocationApi from '../../api/companyallocation'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
export default {
  name: 'companyallocation',
  props: ['currentPage', 'pageSize', 'searchText', 'sort', 'sortOrder'],
  data () {
    return {
      repaircheckList: [], // 报修邮件配置
      loadingSave: false // 保存按钮加loding
    }
  },
  beforeRouteEnter (to, from, next) {
    NProgress.configure({
      easing: 'ease',
      speed: 500,
      showSpinner: false,
      trickleSpeed: 200,
      minimum: 0.3
    })
    NProgress.start()
    companyallocationApi.GetMailsetting('get', '/ownerInfo/mailsetting')
      .then(res => {
        NProgress.done()
        next(vm => {
          vm.repaircheckList = res.data
        })
      })
      .catch(err => {
        console.log(err)
      })
  },
  created () {
  },
  methods: {
    // 保存数据
    submit () {
      this.loadingSave = true
      var data = []
      var repaircheckList = JSON.parse(JSON.stringify(this.repaircheckList))
      for (var k in repaircheckList) {
        var repairitem = {
          id: repaircheckList[k].id,
          mailType: repaircheckList[k].mailType,
          isEnable: repaircheckList[k].isEnable
        }
        data.push(repairitem)
      }
      companyallocationApi.SaveMailsettingChange('post', '/ownerInfo/mailsettingchange', data)
        .then(res => {
          this.$message({
            type: 'success',
            message: this.$t('LanguageLib.SAVED_SUCCESSFULLY')
          })
          this.loadingSave = false
        })
        .catch(err => {
          this.loadingSave = false
          this.$commonfun.console.log(err)
        })
    }
  }
}
</script>

<style lang="scss">
.mailconfig{
  ul{
    margin: 0;
    padding: 0;
  }
  li{
    list-style: none;
  }
  .return{
    padding-left: 25px;
    position: relative;
    height:50px;
    background:rgba(255,255,255,1);
    line-height: 50px;
    border-bottom: 1px solid #F2F2F2;
  }
  .content::-webkit-scrollbar {
    width: 10px;
    height: 10px;
  }
  .content::-webkit-scrollbar-thumb {
    border-radius: 5px;
    -webkit-box-shadow: inset 0 0 5px rgba(255,255,255,0.2);
    background: #E1E1E1;
  }
  .content::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 5px rgba(255,255,255,0.2);
    border-radius: 5px;
    background: #fff;
  }
  .content{
    box-sizing: border-box;
    background:rgba(255,255,255,1);
    width: 100%;
    height: calc( 100% - 50px);
    overflow-y: auto;
    padding-left: 25px;
    padding-top: 15px;
    .title{
      font-size: 16px;
      font-weight: 500;
      color: #606266;
      margin-bottom: 20px;
      .remarks{
        width: 12px;
        height: 12px;
        background: #C9C9C9;
        border-radius: 50%;
        display: inline-block;
        color: #fff;
        font-size: 12px;
        text-align: center;
        line-height: 12px;
      }
    }
    .ModuleBox::-webkit-scrollbar {
      width: 10px;
      height: 10px;
    }
    .ModuleBox::-webkit-scrollbar-thumb {
      border-radius: 5px;
      -webkit-box-shadow: inset 0 0 5px rgba(255,255,255,0.2);
      background: #E1E1E1;
    }
    .ModuleBox::-webkit-scrollbar-track {
      -webkit-box-shadow: inset 0 0 5px rgba(255,255,255,0.2);
      border-radius: 5px;
      background: #fff;
    }
    .ModuleBox{
      width: 300px;
      height: 400px;
      border: 1px solid #E1E1E1;
      overflow-y: auto;
      overflow-x: hidden;
      box-sizing: border-box;
      .el-divider--horizontal{
        margin: 0;
        width: calc(100% - 10px);
      }
      .el-collapse-item__wrap{
        border: 0;
      }
      .el-collapse-item__header{
        border: 0;
      }
      .colorbox{
        width: 16px;
        height: 16px;
        display: inline-block;
      }
      .el-collapse-item {
        padding-left: 10px;
      }
      .el-collapse-item__content {
        padding: 0;
      }
    }
    .ColorPickBox{
      width: 600px;
      height: 400px;
      margin-left: 10px;
      .el-color-picker{
        width: 120px;
      }
      .el-color-picker__trigger{
        width: 120px;
      }
      .radioPick{
        width: 100%;
        height: 48px;
        border: 1px solid #E1E1E1;
        padding-left: 25px;
        line-height: 48px;
        box-sizing: border-box;
      }
      .colorPick::-webkit-scrollbar {
        width: 10px;
        height: 10px;
      }
      .colorPick::-webkit-scrollbar-thumb {
        border-radius: 5px;
        -webkit-box-shadow: inset 0 0 5px rgba(255,255,255,0.2);
        background: #E1E1E1;
      }
      .colorPick::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 5px rgba(255,255,255,0.2);
        border-radius: 5px;
        background: #fff;
      }
      .colorPick{
        width: 100%;
        height: 352px;
        padding-left: 25px;
        border: 1px solid #E1E1E1;
        border-top: 0;
        overflow-y: auto;
        overflow-x: hidden;
      }
    }
    .checkbox{
      padding-left: 16px;
      display: flex;
      flex-wrap: wrap;
      .checkboxItem{
        width: 240px;
        margin-right: 10px;
        margin-bottom: 20px;
        cursor: pointer;
        font-size: 14px;
        font-weight: 400;
        color: #606266;
        .el-checkbox{
          margin-right: 10px;
        }
        .el-checkbox__label{
          width: 216px;
          overflow: hidden;
          text-overflow:ellipsis;
          white-space: nowrap;
          vertical-align: bottom;
        }
      }
    }
  }
  // 修改按钮样式
  .el-button--primary{
    background-color: #3BC6B9;
    border-color: #3BC6B9;
    height: 30px;
    padding: 7px 20px;
    margin-bottom: 15px;
  }
  // 修改按钮样式
  .el-button--default{
    height: 30px;
    padding: 7px 20px;
    margin-bottom: 15px;
  }
  .el-button--default:focus, .el-button--default:hover{
    color: #3BC6B9;
    border-color: #3BC6B9;
  }
  .el-textarea__inner{
    font: 400 14px Arial;
  }
  .el-input .is-disabled{
    color: #2c3e50;
  }
}
.el-tooltip__popper.is-light{
  box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
  border: 1px solid #E4E7ED !important;
  background-color: #fff;
  color: #606266;
  .popper__arrow{
    border-top-color: #E4E7ED;
    border: #E4E7ED;
  }
  .popper__arrow::after{
    border-top-color: #fff;
  }
}

</style>
